export default __webpack_public_path__ + "static/media/invoiceDesktop.68262aa2.jpg";